/**
 * Created by mark on 6/27/2019.
 */
import Service from "../../../Services/index";
import moment from "moment";

const TaxInvoice = {
    namespaced: true,
    state: {
        TaxInvoiceList: [],
        form : {
            id : '',
            invoice_id : '',
            date : '',
            tax_invoice : '',
            total : '',
            tax : '',
            invoice : '',
        },
        search:{
            tax_number: "",
            invoice: '',
            customer : null,
            date : [],
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_TAX_INVOICE:(state,res)=>{
            state.TaxInvoiceList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_FORM_TAX_INVOICE:(state,res)=>{
          state.form = res;
        },
        CLEAR_SEARCH : state=>{
            state.search = {
                tax_number: "",
                invoice: '',
                customer : null,
                date : [],
            }
        }

    },
    actions: {
        setTaxInvoice({commit}, page = 1) {
            return Service.TaxInvoice.getTaxInvoice(page).then(res => {
                commit("GET_TAX_INVOICE", res);
            });
        },
        saveTaxInvoice({commit},{id,data}){
            console.log(data);
            if(!id){
                return Service.TaxInvoice.createTaxInvoice(data);
            }
            else{
                return Service.TaxInvoice.updateTaxInvoice(id,data);
            }
        },
        showTaxInvoice({commit},id){
          return Service.TaxInvoice.showTaxInvoice(id).then(res=>{
              commit('SET_FORM_TAX_INVOICE',res);
          });
        },
        deleteTaxInvoice({commit},id){
          return Service.TaxInvoice.deleteTaxInvoice(id);
        },
        search({commit},{page=1,data}){
            return Service.TaxInvoice.searchTaxInvoice(page,data).then(res=>{
                commit("GET_TAX_INVOICE",res)
            })
        },
        selectTaxInvoiceAll({commit}){
            return Service.TaxInvoice.selectTaxInvoiceAll();
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        getInvoiceByStatusTax({commit}){
            return Service.TaxInvoice.getInvoiceByStatusTax();
        },
        printMultiTax({commit},id){
            return Service.TaxInvoice.printMultipleTax(id);
        },
    }
};

export default TaxInvoice;
